import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE_URL = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// API service functions
export const apiService = {
  // Contact form submission
  submitContactForm: async (formData) => {
    try {
      const response = await apiClient.post('/contact', formData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get company statistics
  getCompanyStats: async () => {
    try {
      const response = await apiClient.get('/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching stats:', error);
      // Return default values if API fails
      return {
        clientCount: "500+",
        invoicesProcessed: "2.5M+",
        costSavingsGenerated: "Real Time",
        accuracyRate: "Self-improving",
        averageProcessingTime: "24 hours",
        clientRetentionRate: "Top Quartile",
        yearsInBusiness: "15+",
        countriesServed: "25+"
      };
    }
  },

  // Get testimonials
  getTestimonials: async (featuredOnly = false) => {
    try {
      const response = await apiClient.get('/testimonials', {
        params: { featured_only: featuredOnly }
      });
      return response.data.testimonials;
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      return [];
    }
  },

  // Get services
  getServices: async () => {
    try {
      const response = await apiClient.get('/services');
      return response.data.services;
    } catch (error) {
      console.error('Error fetching services:', error);
      return [];
    }
  },

  // Newsletter subscription
  subscribeNewsletter: async (subscriptionData) => {
    try {
      const response = await apiClient.post('/newsletter', subscriptionData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Health check
  healthCheck: async () => {
    try {
      const response = await apiClient.get('/health');
      return response.data;
    } catch (error) {
      console.error('Health check failed:', error);
      return { status: 'unhealthy' };
    }
  }
};

export default apiService;